import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { SharedDeviationsModule } from '../../shared/deviations/deviations.module';
import { JBMButtonsModule } from '../../components/JBM/Buttons/jbmbuttons.module';
import { JBMViewModule } from '../../components/JBM/Views/jbmview.module';
import { JBMDashboardModule } from '../../components/JBM/Dashboard/dashboard.module';
import { JBMSelectsModule } from '../../components/JBM/Selects/jbmselects.module';
import { DASHBOARD_WIDGETS } from '../../components/JBM/Dashboard/registry/dashboard-widget.token';
import { DashboardWidgetRegistration } from '../../components/JBM/Dashboard/models/dashboard-widget.types';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { LayoutModule } from '../../layout/layout.module';
import { WidgetProjectsComponent } from './widgets/widget-projects/widget-projects.component';
import { WidgetQuotationsComponent } from './widgets/widget-quotations/widget-quotations.component';
import { WidgetInvoicingComponent } from './widgets/widget-invoicing/widget-invoicing.component';
import { WidgetProductionComponent } from './widgets/widget-production/widget-production.component';
import { DashboardOperationalComponent } from './operational/operational.component';
import { DashboardSummaryComponent } from './operational/summary/summary.component';
import { DashboardPlantsProductionComponent } from './operational/plants-production/plants-production.component';
import { DashboardOrderStatusComponent } from './operational/order-status/order-status.component';
import { DashboardDayFilterComponent } from './period-pickers/dashboard-day-filter/dashboard-day-filter.component';
import { JBMDashboardDateRangeFilterComponent } from './period-pickers/dashboard-date-range-filter/dashboard-date-range-filter.component';
import { DashboardProjectDeviationsComponent } from './operational/project-deviations/project-deviations.component';
import { DashboardOrderDeliveriesComponent } from './operational/deliveries/deliveries.component';
import { DashboardPlantCapacitiesComponent } from './operational/capacities/capacities.component';
import { DashboardInvoicingSummaryComponent } from './financial/invoicing/summary/summary.component';
import { DashboardInvoicingDeviationsComponent } from './financial/invoicing/deviations/deviations.component';


import { DashboardCustomersListComponent } from './financial/customers/list/list.component';
import { DashboardCustomersSummaryComponent } from './financial/customers/summary/summary.component';
import { DashboardCustomersDeviationsComponent } from './financial/customers/deviations/deviations.component';
import { DashboardPriceAgreementsSummaryComponent } from './financial/price-agreements/summary/summary.component';
import { DashboardPriceAgreementsExpireListComponent } from './financial/price-agreements/expire-list/expire-list.component';
import { DashboardQuotationsComponent } from './financial/quotations/quotations.component';
import { DashboardFinancialComponent } from './financial/financial.component';
import { DashboardCustomersComponent } from './financial/customers/customers.component';
import { DashboardInvoicingComponent } from './financial/invoicing/invoicing.component';
import { DashboardPriceAgreementsComponent } from './financial/price-agreements/price-agreements.component';
import { DashboardInvoicingListComponent } from './financial/invoicing/list/list.component';

const APP_WIDGETS: DashboardWidgetRegistration[] = [
  {
    type: 'projects.overview',
    component: WidgetProjectsComponent,
    width: 8,
    height: 7,
    closeable: true,
    visible: true,
    defaultSettings: { plantId: 0 }
  },
  {
    type: 'production.today',
    component: WidgetProductionComponent,
    width: 8,
    height: 7,
    closeable: true,
    visible: true,
    defaultSettings: { plantId: 0 }
  }
];

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    SharedDeviationsModule,
    JBMButtonsModule,
    JBMViewModule,
    JBMDashboardModule,
    JBMSelectsModule,
    LayoutModule
  ],
  declarations: [
    DashboardComponent,
    WidgetProjectsComponent,
    WidgetQuotationsComponent,
    WidgetInvoicingComponent,
    WidgetProductionComponent,
    DashboardOperationalComponent,
    DashboardSummaryComponent,
    DashboardPlantsProductionComponent,
    DashboardOrderStatusComponent,
    DashboardDayFilterComponent,
    JBMDashboardDateRangeFilterComponent,
    DashboardProjectDeviationsComponent,
    DashboardOrderDeliveriesComponent,
    DashboardPlantCapacitiesComponent,
    DashboardInvoicingSummaryComponent,
    DashboardInvoicingDeviationsComponent,


    DashboardCustomersListComponent,
    DashboardCustomersSummaryComponent,
    DashboardCustomersDeviationsComponent,
    DashboardPriceAgreementsSummaryComponent,
    DashboardPriceAgreementsExpireListComponent,
    DashboardQuotationsComponent,
    DashboardFinancialComponent,
    DashboardCustomersComponent,
    DashboardInvoicingComponent,
    DashboardPriceAgreementsComponent,
    DashboardInvoicingListComponent
  ],
  providers: [
    { provide: DASHBOARD_WIDGETS, useValue: APP_WIDGETS, multi: true }
  ]
})
export class DashboardModule { }
